import { getDeviceSchema, VOICEMAIL } from "callable-data-objects";
import { GoogleTTSLanguage } from "callable-data-objects/dist/enums/GoogleTTSLanguage";
import { CallableInput, CallableToggle } from "Components/Shared";
import CallableTextArea from "Components/Shared/CallableTextArea";
import FormSubmit from "Components/Shared/FormSubmit";
import TTSSelect from "Components/Shared/TTSSelect";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Divider, Form, Header, Segment } from "semantic-ui-react";

const VoicemailCreate = () => {
  const { save, nextExtension, validateExtension, validateName, uncreate } =
    useDevice();

  const initValues = {
    type: VOICEMAIL,
    name: "",
    extension: nextExtension,
    voicemail: {
      text: "",
      finishOnKey: "#",
      maxLength: 30,
      timeout: 10,
      transcribe: false,
      playBeep: true,
      connectTo: "HANGUP",
      ttsLanguage: GoogleTTSLanguage.English_UK_Standard_A_Female,
    },
  };

  return (
    <Segment>
      <Header as='h3'>Create Voicemail</Header>
      <Divider />
      <Formik
        initialValues={initValues}
        validationSchema={getDeviceSchema(VOICEMAIL)}
        onSubmit={(values, actions) => {
          save(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />

            <Field
              name='extension'
              label='Extension'
              placeholder='100'
              min='100'
              max='900'
              type='number'
              validate={validateExtension}
              component={CallableInput}
            />

            <Field
              name='voicemail.text'
              label='Text'
              type='textarea'
              component={CallableTextArea}
            />

            <TTSSelect label='language' name='voicemail.ttsLanguage' />

            <Field
              name='voicemail.finishOnKey'
              label='Finish On Key'
              type='text'
              component={CallableInput}
            />
            <Field
              name='voicemail.timeout'
              label='Timeout'
              type='number'
              min='3'
              max='10'
              component={CallableInput}
            />
            <Field
              name='voicemail.maxLength'
              label='Max VM Length'
              type='number'
              min='10'
              max='60'
              component={CallableInput}
            />
            <Field
              name='voicemail.emailRecipients[0]'
              label='Send to Email'
              component={CallableInput}
            />

            {/* <Field
              toggle
              name={`voicemail.transcribe`}
              label='Transcribe'
              component={CallableToggle}
            /> */}

            <Field
              toggle
              name={`voicemail.playBeep`}
              label='Beep'
              component={CallableToggle}
            />

            <FormSubmit
              name='Create Voicemail'
              onCancel={uncreate}
              errors={props.errors}
            />
          </Form>
        )}
      </Formik>
    </Segment>
  );
};

export default VoicemailCreate;
